module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar', {
    attrs: {
      "back": "",
      "fixed": "",
      "bg": ""
    }
  }, [_c('span', {
    slot: "title"
  }, [_vm._v("实名认证")])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn-submit",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.goApp
    }
  }, [_vm._v("立即前往")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-caption"
  }, [_c('h3', {
    staticClass: "group-title",
    staticStyle: {
      "margin-top": "132px",
      "font-size": "24px"
    }
  }, [_vm._v("温馨提示")]), _vm._v(" "), _c('div', {
    staticClass: "point"
  }), _vm._v(" "), _c('p', {
    staticClass: "bottom group-title"
  }, [_vm._v("请使用APP来完成实名认证操作，如未安装APP请前往下载页面安装。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a15578f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sign/authentication.vue
// module id = 366
// module chunks = 1